import styled from 'styled-components';

export const Text = styled.div`
  font: 400 16px/20px ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.fontColor};
  margin-top: -18px;
  margin-bottom: 28px;
`;
